import {
  Box,
  Typography,
  Image,
  Flex,
  Divider,
  MediaBox,
  MediaFlex,
} from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { to_currency } from "helpers/number"

const Plan = styled(Flex).attrs({
  height: "115px",
  mx: "auto",
  width: "120px",
})`
  align-items: center;
  border: 2px solid
    ${(props) =>
      props.selected
        ? props.theme.colors.selected
        : props.theme.extendWarranty.cartAddon.color};
  border-radius: 5px;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-evenly;
  margin-bottom: 24px;
  margin-top: -4px;
  padding: 16px 2px 12px;
  text-align: center;
  transition: all 0.2s;
  ${(props) =>
    props.selected &&
    `
    position: relative;
    border: 2px solid ${props.theme.colors.selected};
    opacity: 1;
    &:after {
      display: block;
      position: absolute;
      content: url(${sl.config.jewlr_asset_url}images/icons/jewlr4-checkmark.svg);
      transform: scale(0.8);
      bottom: -12px;
      left: 60%;
      margin-left: -18px;
      width: 22px;
      height: 22px;
    }
  `}
`
const PlanLabel = styled(Typography).attrs((props) => ({
  mx: "auto",
  width: "120px",
  ...props,
}))`
  background-color: ${(props) =>
    props.selected
      ? props.theme.colors.selected
      : props.theme.extendWarranty.cartAddon.color};
  color: white;
  text-align: center;
  height: 22px;
  padding-top: 2px;
  position: relative;
  :after {
    position: absolute;
    display: block;
    content: " ";
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid
      ${(props) =>
        props.selected
          ? props.theme.colors.selected
          : props.theme.extendWarranty.cartAddon.color};
    left: 51px;
    margin-top: 1px;
  }
`
const ProtectionProducts = ({ data, selectedOffers, setSelectedOffers }) => {
  return (
    <>
      {data?.line_items?.map((item) => (
        <Box key={item.id} mx={{ _: 2, tablet: 0 }} py={3}>
          <MediaFlex alignItems="center" lessThan="desktop" ml={3}>
            <Box flex="1">
              <Image src={item.url} width="190px" />
            </Box>
            <Box flex="2" px={2}>
              <Typography as="h1" fontSize={18} mb={1}>
                {item.title}
              </Typography>
              <Typography mb={2}>Add a protection plan:</Typography>
            </Box>
          </MediaFlex>
          <Flex>
            <MediaBox flex="1 1 auto" greaterThanOrEqual="desktop">
              <Image src={item.url} width="190px" />
            </MediaBox>

            <Box flex={{ _: 1, desktop: "4 1 auto" }}>
              <Typography
                as="h1"
                display={{ _: "none", desktop: "block" }}
                fontSize={18}
                mb={1}
              >
                {item.title}
              </Typography>
              <Typography display={{ _: "none", desktop: "block" }} mb={2}>
                Add a protection plan:
              </Typography>
              <Flex
                alignItems="flex-start"
                flexWrap={{ _: "wrap", tablet: "nowrap" }}
                gutter={{ _: 3, tablet: 1 }}
                justifyContent={{ _: "center", desktop: "left" }}
                pb={2}
              >
                {item.offers.plans.adh.map((plan) => (
                  <Box
                    key={`warranty-plan-${plan.value}`}
                    pb={{ _: 2, tablet: 0 }}
                  >
                    {plan.label ? (
                      <PlanLabel
                        selected={
                          selectedOffers[item.id] &&
                          selectedOffers[item.id]["id"] === plan.id
                        }
                      >
                        {plan.label}
                      </PlanLabel>
                    ) : (
                      <Box height={{ _: "22px", tablet: "22px" }} />
                    )}
                    <Plan
                      label={plan.label}
                      onClick={() => {
                        let planObj = { ...selectedOffers }
                        planObj[item.id] = plan

                        if (
                          selectedOffers[item.id] &&
                          selectedOffers[item.id]["id"] === plan.id
                        ) {
                          planObj[item.id] = "No warranty"
                          setSelectedOffers(planObj)
                        } else {
                          setSelectedOffers(planObj)
                        }
                      }}
                      selected={
                        selectedOffers[item.id]
                          ? selectedOffers[item.id]["id"] === plan.id
                          : false
                      }
                    >
                      <Image
                        alt="Extend Warranty"
                        src={require("images/icons/extend_icon.svg")}
                        title="Extend Warranty"
                        width="25%"
                      />

                      <Typography fontWeight="700">{plan.duration}</Typography>
                      <Typography>Protection Plan</Typography>
                      <Typography>
                        {to_currency(plan.price, { precision: 2 })}
                      </Typography>
                    </Plan>
                  </Box>
                ))}
              </Flex>
            </Box>
          </Flex>
          <Divider />
        </Box>
      ))}
    </>
  )
}

ProtectionProducts.propTypes = {
  data: PropTypes.object,
  selectedOffers: PropTypes.object,
  setSelectedOffers: PropTypes.func,
}

export default ProtectionProducts
